import { Helmet } from 'react-helmet-async';
// sections
import Login from '../../sections/auth/Login';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Logowanie | Vetsi</title>
        <link rel="canonical" href="https://app.vetsi.pl/auth/login" />
      </Helmet>

      <Login />
    </>
  );
}
